import styles from './Emoji.module.css'

type Props = {
	char: string
	label: string
	className?: string
}

const toCodepoint = (char: string): string =>
	[...char]
		.map((c) => c.codePointAt(0)!)
		.filter((cp) => cp !== 0xfe0f)
		.map((cp) => cp.toString(16))
		.join('-')

export const Emoji = ({ char, label, className }: Props) => (
	<img
		src={`/emoji/${toCodepoint(char)}.svg`}
		alt={label}
		draggable={false}
		className={className ? `${styles.root} ${className}` : styles.root}
	/>
)
